<template>
    <div>
        <br>
        <div class="row">
            <div class="col-sm-2">
                <span>Provinsi</span>
            </div>
            <div class="col-sm-1">
                <input type="text" class="form-control" value="74" disabled>
            </div>
            <div class="col-sm-3">
                <input type="text" class="form-control" value="SULAWESI TENGGARA" disabled>
            </div>
        </div>
        <br>
        <div class="row">
            <div class="col-sm-2">
                <span>Kota/Kab</span>
            </div>
            <div class="col-sm-1">
                <input type="text" class="form-control" value="05">
            </div>
            <div class="col-sm-3">
                <input type="text" class="form-control" value="KONAWE SELATAN">
            </div>
        </div>
        <br>
        <div class="row">
            <div class="col-sm-2">
                <span>Kecamatan</span>
            </div>
            <div class="col-sm-1">
                <input type="text" class="form-control">
            </div>
            <div class="col-sm-3">
                <input type="text" class="form-control" disabled>
            </div>
        </div>
        <br>
        <div class="row">
            <div class="col-sm-2">
                <span>Kelurahan</span>
            </div>
            <div class="col-sm-1">
                <input type="text" class="form-control">
            </div>
            <div class="col-sm-3">
                <input type="text" class="form-control" disabled>
            </div>
        </div>
        <br>
        <div class="row">
            <div class="col-sm-2">
                <span>Tahun Pajak Awal</span>
            </div>
            <div class="col-sm-1">
                <input type="text" class="form-control">
            </div>
        </div>
        <br>
        <div class="row">
            <div class="col-sm-2">
                <span>Tahun Pajak Akhir</span>
            </div>
            <div class="col-sm-1">
                <input type="text" class="form-control">
            </div>
        </div>
        <br>
        <div class="row">
            <div class="col-sm-2">
                <span>Buku</span>
            </div>
            <div class="col-sm-2">
                <select class="form-control">
                    <option>1</option>
                    <option>1,2</option>
                    <option>1,2,3</option>
                    <option>1,2,3,4</option>
                    <option>1,2,3,4,5</option>
                    <option>2</option>
                    <option>2,3</option>
                    <option>2,3,4</option>
                    <option>2,3,4,5</option>
                    <option>3</option>
                    <option>3,4</option>
                    <option>3,4,5</option>
                    <option>4</option>
                    <option>4,5</option>
                    <option>5</option>
                </select>
            </div>
        </div>
        <br>
        <div class="row">
            <div class="col-sm-2">
                <span>Ketetapan PBB Awal</span>
            </div>
            <div class="col-sm-2">
                <input type="text" class="form-control" disabled>
            </div>
        </div>
        <br>
        <div class="row">
            <div class="col-sm-2">
                <span>Ketetapan PBB Akhir</span>
            </div>
            <div class="col-sm-2">
                <input type="text" class="form-control" disabled>
            </div>
        </div>
        <br>
        <br> <hr>
        <div class="row">
            <div class="col-sm-2"></div>
            <div class="col-sm-10">
                <button type="button" class="btn bg-light-blue btn-sm waves-effect"><i class="material-icons">print</i>Cetak</button>
            </div>
        </div>        
        <br>
    </div>
</template>

<script>
export default {

}
</script>

<style>

</style>
